import React from 'react';
import {Button, Row, Col} from 'react-bootstrap';
import Component from '../../components/AscComponent';
import CommonTable from '../../containers/Elements/Table/CommonTable';
import PartnerDeleteModal from './PartnerDeleteModal';
import PartnerInsertModal from './PartnerInsertModal';
import PartnerUpdateModal from './PartnerUpdateModal';
import PartnerReadModal from './PartnerReadModal';

// S3バケット名バリデーション（バックエンドと同じ正規表現に統一）
// - 3〜63文字、英小文字・数字・ハイフン・ドットのみ、先頭・末尾はハイフン・ドット不可
// - IPアドレス形式不可、xn-- プレフィックス不可
const S3_BUCKET_NAME_REGEX = /^(?!xn--)(?!\d+\.\d+\.\d+\.\d+$)[a-z0-9][a-z0-9.-]{1,61}[a-z0-9]$/;

export default class Partner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            pageSize: 20,
            pages: null,
            loading: false,
            filtered: [],
            sorted: [{id: 'id', desc: true}],

            selectedData: [],

            // modal item
            show: false,
            modalType: null,

            // CSV
            csvDownloading: false,
            DownloadData: null
        };
    }

    /**
     * 一覧表作成
     */
    getColumnsData() {
        return [
            {
                Header: this.props.langText.Body.PartnerId,
                accessor: 'id',
                width: this.props.boardWidth.xsmall,
                disableFilters: true
            }, {
                Header: this.props.langText.Body.PartnerName,
                accessor: 'name',
                width: this.props.boardWidth.large,
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "name")}
                    />
            }, {
                Header: this.props.langText.Body.PartnerS3BucketName,
                accessor: 's3_bucket_name',
                width: this.props.boardWidth.large,
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "s3_bucket_name")}
                    />
            }, {
                Header: this.props.langText.Body.PartnerDomain,
                accessor: 'domain',
                width: this.props.boardWidth.large,
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "domain")}
                    />
            }, {
                Header: this.props.langText.Body.PartnerIdentifier,
                accessor: 'identifier',
                width: this.props.boardWidth.medium,
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "identifier")}
                    />
            }, {
                Header: this.props.langText.Body.PartnerCreated,
                accessor: 'created',
                width: this.props.boardWidth.Date,
                disableFilters: true
            }, {
                Header: this.props.langText.Body.PartnerModified,
                accessor: 'modified',
                width: this.props.boardWidth.Date,
                disableFilters: true
            }
        ]
    }

    /**
     * 各ボタンから新しいmodal表示する際に使用する関数
     */
    modalShow = (modalType) => async event => {
        event.preventDefault();
        try {
            let {selectedData} = this.state;

            if ((modalType === "update" || modalType === "delete" || modalType === "read") && selectedData.length === 0) {
                return this.showErrorObjectMessage('Partner_ModalSelectError');
            } else if (modalType === "update" && selectedData.length > 1) {
                return this.showErrorObjectMessage('Partner_UpdateModalSelectError');
            }

            let updateData = (modalType === "update" || modalType === "read") && selectedData.slice().pop();

            // 更新モーダルの場合は最新データを取得
            if (modalType === "update" && updateData && updateData.id) {
                const response = await this.ascAxios('get', `Partner/getPartner/${updateData.id}`);
                updateData = response.data;
            }

            let setData = {
                hm12_id: updateData && updateData.id
                    ? updateData.id
                    : 0,
                name: updateData && updateData.name
                    ? updateData.name
                    : '',
                s3_bucket_name: updateData && updateData.s3_bucket_name
                    ? updateData.s3_bucket_name
                    : '',
                domain: updateData && updateData.domain
                    ? updateData.domain
                    : '',
                identifier: updateData && updateData.identifier
                    ? updateData.identifier
                    : '',
                options: updateData && updateData.options
                    ? JSON.stringify(updateData.options, null, 2)
                    : '{}',
                created: updateData && updateData.created
                    ? updateData.created
                    : '',
                modified: updateData && updateData.modified
                    ? updateData.modified
                    : '',
                modalType: modalType,
                show: true
            };

            if (modalType === "delete") {
                const selectedIds = selectedData.map(row => row.id);
                // selectedDataは選択時のスナップショットのため、最新の一覧データからIDで名前を取得
                const freshRows = this.state.data.filter(row => selectedIds.includes(row.id));
                setData.hm12_id = freshRows.map(row => row.id);
                setData.name = freshRows.map(row => row.name || '');
            }

            this.setState(setData);
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err);
        }
    };

    onClickHandle = modalType => async () => {
        let {
            name,
            s3_bucket_name,
            domain,
            identifier,
            options,
            hm12_id
        } = this.state;

        try {
            // optionsをJSONパース
            let parsedOptions = {};
            if (options && options.trim() !== '') {
                try {
                    parsedOptions = JSON.parse(options);
                } catch (e) {
                    return this.showErrorObjectMessage('Partner_InvalidJsonError');
                }
            }

            switch (modalType) {
                case 'insert':
                    this.blockUI();
                    await this.ascAxios('post', `Partner/createPartner`, {
                        name,
                        s3_bucket_name,
                        domain,
                        identifier,
                        options: parsedOptions
                    });
                    alert(this.props.langText.Message.DataInsertSuccess);
                    this.reactTableRefresh(true);
                    break;
                case 'update':
                    this.blockUI();
                    await this.ascAxios('put', `Partner/updatePartner`, {
                        id: hm12_id,
                        name,
                        s3_bucket_name,
                        domain,
                        identifier,
                        options: parsedOptions
                    });
                    alert(this.props.langText.Message.DataUpdateSuccess);
                    this.reactTableRefresh(true);
                    break;
                case 'delete':
                    this.blockUI();
                    await this.ascAxios('post', `Partner/deletePartner`, {
                        ids: hm12_id
                    });
                    alert(this.props.langText.Message.DataDeleteSuccess);
                    this.reactTableRefresh(true);
                    break;
                default:
                    this.showErrorObjectMessage('ModalTypeError');
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err);
        } finally {
            this.setState({show: false});
        }
    };

    modalClose = () => {
        this.setState({show: false});
    }

    downloadCsv = async () => {
        try {
            this.setState({csvDownloading: true});
            const result = await this.ascAxios('post', 'Partner/exportCsv');
            const rows = result.data.rows || [];
            const csvContent = this.generatePartnerCSV(rows);
            const now = new Date();
            const ts = `${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}_${String(now.getHours()).padStart(2,'0')}${String(now.getMinutes()).padStart(2,'0')}${String(now.getSeconds()).padStart(2,'0')}`;
            this.downloadCSVFile(csvContent, `パートナー一覧_${ts}.csv`);
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err);
        } finally {
            this.setState({csvDownloading: false});
        }
    };

    generatePartnerCSV = (rows) => {
        const headers = [
            this.props.langText.Body.PartnerId,
            this.props.langText.Body.PartnerName,
            this.props.langText.Body.PartnerS3BucketName,
            this.props.langText.Body.PartnerDomain,
            this.props.langText.Body.PartnerIdentifier,
            this.props.langText.Body.PartnerOptions,
            this.props.langText.Body.PartnerCreated,
            this.props.langText.Body.PartnerModified
        ];
        const escape = v => {
            if (v === null || v === undefined) return '';
            let s = typeof v === 'object' ? JSON.stringify(v) : String(v);
            if (/^[=+\-@]/.test(s)) s = "'" + s;
            if (s.includes(',') || s.includes('"') || s.includes('\n')) s = '"' + s.replace(/"/g, '""') + '"';
            return s;
        };
        const dataRows = rows.map(r => [r.id, r.name, r.s3_bucket_name, r.domain, r.identifier, r.options, r.created, r.modified].map(escape).join(','));
        return '\uFEFF' + [headers.join(','), ...dataRows].join('\n');
    };

    downloadCSVFile = (content, filename) => {
        const blob = new Blob([content], {type: 'text/csv;charset=utf-8;'});
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    /**
     * 各画面のボタン押下条件
     */
    validationHandle = param => {
        let validation_flag = false;
        let {name, s3_bucket_name, identifier} = this.state;

        switch (param) {
            case 'insert':
            case 'update':
                validation_flag = !!(name && s3_bucket_name && identifier)
                    && S3_BUCKET_NAME_REGEX.test(s3_bucket_name);
                break;
            case 'read':
            case 'delete':
                validation_flag = name.length > 0;
                break;
            default:
                break;
        }
        return validation_flag;
    };

    /**
     * modalTypeにより分岐させる
     */
    getModalBranch = () => {
        let commonProps = {
            state: this.state,
            userInfo: this.props.userInfo,
            propSetState: this.propSetState,
            langText: this.props.langText,
            charaLimit: this.props.charaLimit,
            boardWidth: this.props.boardWidth,
            onClick: this.onClickHandle,
            validationHandle: this.validationHandle,
            modalClose: this.modalClose
        };

        switch (this.state.modalType) {
            case 'insert':
                return <PartnerInsertModal {...commonProps} onTextChange_Limit={this.onTextChange_Limit}/>;
            case 'update':
                return <PartnerUpdateModal {...commonProps} onTextChange_Limit={this.onTextChange_Limit}/>;
            case 'delete':
                return <PartnerDeleteModal {...commonProps}/>;
            case 'read':
                return <PartnerReadModal {...commonProps}/>;
            default:
                break;
        }
    }

    render() {
        return (
            <div className='Partner'>
                {/*一覧画面*/}
                <Row>
                    <Col xs={12} md={12}>
                        <Button
                            id='partner-insert'
                            className='table-button'
                            variant='default'
                            size='sm'
                            onClick={this.modalShow('insert')}
                            hidden={!this.props.currentPermission.create}
                        >
                            {this.props.langText.Body.InsertTitle}
                        </Button>
                        <Button
                            id='partner-update'
                            className='table-button'
                            variant='default'
                            size='sm'
                            onClick={this.modalShow('update')}
                            hidden={!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.UpdateTitle}
                        </Button>
                        <Button
                            id='partner-read'
                            className='table-button'
                            variant='default'
                            size='sm'
                            onClick={this.modalShow('read')}
                            hidden={!!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.ReadTitle}
                        </Button>
                        <Button
                            id='partner-delete'
                            className='table-button'
                            variant='default'
                            size='sm'
                            onClick={this.modalShow('delete')}
                            hidden={!this.props.currentPermission.delete}
                            disabled={this.state.selectedData.length === 0}
                        >
                            {this.props.langText.Body.DeleteTitle}
                        </Button>
                        <Button
                            id='partner-csv'
                            className='table-button'
                            variant='default'
                            size='sm'
                            onClick={this.downloadCsv}
                            hidden={!this.props.currentPermission.download}
                            disabled={this.state.csvDownloading}
                        >
                            {this.props.langText.Body.CsvDownload}
                        </Button>
                    </Col>
                    <Col xs={12} md={12}>
                        <CommonTable
                            state={this.state}
                            tableHeight={this.props.tableHeight}
                            tbodyHeight={this.props.tableHeight - 30}
                            propsPageIndex={this.state.pageIndex ? this.state.pageIndex : 0}
                            columns={this.state.columns}
                            data={this.state.data}
                            pageSize={this.state.pageSize}
                            loading={this.state.loading}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            sorted={this.state.sorted}
                            pageCount={this.state.pageCount}
                            manual={true}
                            showPagination={true}
                            showCheckbox={true}
                            onSelectedDataChange={(selected) => {
                                this.setState({selectedData: selected});
                            }}
                            showPageSize={true}
                            showFilter={true}
                            langText={this.props.langText.Table}
                        />
                    </Col>
                </Row>
                {/*モーダル表示分岐*/}
                {this.getModalBranch()}
            </div>
        );
    }
}
